module.exports = __webpack_public_path__ + "static/img/processing.cf8ba63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/processing.png
// module id = o9M/
// module chunks = 6